export default __webpack_public_path__ + "static/business-insider-e7bf91824bca2a0acc90831501a05175.png";